import { GoogleMap, useLoadScript, Marker} from '@react-google-maps/api';
import {useMemo} from "react";

const Map = ({markers}) => {
    const libraries = ['places'];

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries,
    });
    const center = useMemo(() => ({lat:48.6530068, lng: 6.1481188}), []);

    const containerStyle = {
        width: '100%',
        height: '400px'
    };

    if (loadError) return "Error";
    if (!isLoaded) return "Loading...";

    const open = (event) => {
        window.open("https://www.google.com/maps/search/?api=1&query="+event.latLng.lat()+","+event.latLng.lng(), "_blank")
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={8}
        >
            {markers.map(({position, name},id) => (
                <Marker key={id} position={position} label={name} onClick={open}/>
            ))}
        </GoogleMap>
    );
}

export default Map;